import { Card, Grid, RadioGroup, FormControlLabel, Radio, Box } from "@mui/material";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import { NutritionalRiskScoreFormData } from "../models/types";

interface AssessmentFormProps {
    formData: NutritionalRiskScoreFormData;
    onChange: (key: string, value: any) => void;
}

export const AssessmentForm = ({ formData, onChange }: AssessmentFormProps) => {
    const { t } = useTranslate();

    const radioItems = [
        { title: t("nutritional-risk-score.body-mass"), key: 'BODY_MASS_INDEX_SCORE', expKey: 'BODY_MASS_INDEX_SCORE_EXP' },
        { title: t("nutritional-risk-score.food"), key: 'REDUCTION_FOOD_PURCHASE', expKey: 'REDUCTION_FOOD_PURCHASE_EXP' },
        { title: t("nutritional-risk-score.lost-weight"), key: 'WEIGHT_LOSS', expKey: 'WEIGHT_LOSS_TREE_MONTHS_EXP' },
        { title: t("nutritional-risk-score.extremely"), key: 'ADVANCED_PATIENT', expKey: 'ADVANCED_PATIENT_EXP' }
    ];

    return (
        <Card sx={{ marginBottom: "10px", pb: 2 }}>
            <Grid container spacing={2} sx={{ px: 2, pt: 2 }}>
                <Grid item lg={2} md={3} xl={2}>
                    <ByzTitleAndInputBox title={t("nutritional-risk-score.height-(cm)")}>
                        <ByzMuiTextField
                            type="number"
                            value={formData.HEIGHT || ""}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange("HEIGHT", Number(e.target.value))}
                        />
                    </ByzTitleAndInputBox>
                </Grid>
                <Grid item lg={2} md={3} xl={2}>
                    <ByzTitleAndInputBox title={t("nutritional-risk-score.weight-(kg)")}>
                        <ByzMuiTextField
                            type="number"
                            value={formData.WEIGHT || ""}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange("WEIGHT", Number(e.target.value))}
                        />
                    </ByzTitleAndInputBox>
                </Grid>
                <Grid item lg={2} md={3} xl={2}>
                    <ByzTitleAndInputBox title={t("nutritional-risk-score.columns.vki")}>
                        <ByzMuiTextField
                            type="number"
                            value={formData.BODY_MASS_INDEX || ""}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange("BODY_MASS_INDEX", Number(e.target.value))}
                        />
                    </ByzTitleAndInputBox>
                </Grid>
                <Grid item lg={6} md={3} xl={6}></Grid>
            </Grid>

            <Box sx={{ width: '100%', px: 2, mt: 3 }}>
                {radioItems.map((item) => (
                    <Grid container key={item.key} spacing={2} sx={{ mb: 2, alignItems: 'center' }}>
                        <Grid item lg={5} md={5} xs={12}>
                            <ByzMuiTypography variant="body1">{item.title}</ByzMuiTypography>
                        </Grid>
                        <Grid item lg={3} md={3} xs={12}>
                            <RadioGroup
                                row
                                value={formData[item.key] !== null && formData[item.key] !== undefined && formData[item.key] !== "" ? String(formData[item.key]) : ""}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(item.key, Number(e.target.value))}
                            >
                                <FormControlLabel value="1" control={<Radio size="small" />} label={t("nutritional-risk-score.yes")} />
                                <FormControlLabel value="0" control={<Radio size="small" />} label={t("nutritional-risk-score.no")} />
                            </RadioGroup>
                        </Grid>
                        <Grid item lg={4} md={4} xs={12}>
                            <ByzMuiTextField
                                fullWidth
                                size="small"
                                value={formData[item.expKey] || ""}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(item.expKey, e.target.value)}
                                disabled={formData[item.key] === null || formData[item.key] === undefined || formData[item.key] === ""}
                            />
                        </Grid>
                    </Grid>
                ))}
            </Box>
        </Card>
    );
};
